import React from 'react';
import styled from 'styled-components';
import { typography, color } from 'styled-system';
const StyledSvg = styled('svg')(typography, color);

const LocationPin = props => (
  <StyledSvg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.8 11.88V18a1.2 1.2 0 102.4 0v-6.12a6 6 0 10-2.4 0zM12 2.4a3.6 3.6 0 110 7.2 3.6 3.6 0 010-7.2zm5.052 12.504a1.226 1.226 0 10-.504 2.4c2.724.54 3.852 1.512 3.852 1.896 0 .696-2.94 2.4-8.4 2.4-5.46 0-8.4-1.704-8.4-2.4 0-.384 1.128-1.356 3.852-1.944a1.226 1.226 0 10-.504-2.4C3.3 15.696 1.2 17.268 1.2 19.2 1.2 22.356 6.636 24 12 24c5.364 0 10.8-1.644 10.8-4.8 0-1.932-2.1-3.504-5.748-4.296z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledSvg>
);
export default LocationPin;
